import React from 'react';
import { Header } from './Header';
import { MessageDisplay } from '../ui/MessageDisplay';

interface AppLayoutProps {
  children: React.ReactNode;
  message?: { type: 'success' | 'error'; text: string } | null;
  onSignOut: () => void;
}

export function AppLayout({ children, message, onSignOut }: AppLayoutProps) {
  return (
    <div className="min-h-screen bg-paper-cream">
      <Header onSignOut={onSignOut} />
      <main className="flex-1 p-4 md:p-8 pb-32 md:pb-16">
        <MessageDisplay message={message} />
        {children}
      </main>
    </div>
  );
} 